import * as React from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { green } from '@mui/material/colors'
import Fab from '@mui/material/Fab'
import CheckIcon from '@mui/icons-material/Check'
import SaveIcon from '@mui/icons-material/Save'
import { useEffect } from 'react'

export default function Progress({loading, statusCode}) {
  const [success, setSuccess] = React.useState(false)
//   const timer = React.useRef()

  const buttonSx = {
    width: '40px',
    height: '40px',
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  }

//   React.useEffect(() => {
//     return () => {
//       clearTimeout(timer.current)
//     }
//   }, [])


  useEffect(() => {
    if (!loading) {
        setSuccess(false)
        //  setLoading(true)
        // timer.current = window.setTimeout(() => {
        //   setSuccess(true)
        //   // setLoading(false)
        // }, 600)
      }
      if(statusCode === 200){
        setSuccess(true)
    }
  }, [loading])
  

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ p: 0, position: 'relative' }}>
        <Fab aria-label="save" color="primary" sx={buttonSx} disabled={!loading}>
          {success ? <CheckIcon /> : <SaveIcon />}
        </Fab>
        {loading && (
          <CircularProgress
            size={45}
            sx={{
              color: green[500],
              position: 'absolute',
              top: -2,
              left: -2,
              zIndex: 1,
            }}
          />
        )}
      </Box>
    </Box>
  )
}
